import Swiper from 'swiper';

const defaultOptions = {
    navigation: {
        prevEl: '.js-slider-arrows-previous',
        nextEl: '.js-slider-arrows-next',
        disabledClass: 'slider-arrows__arrow--disabled',
    },
    slidesPerView: 1,
};

export default class Slider {
    constructor(element, options = defaultOptions) {
        if (!element) return;

        this.swiper = new Swiper(element, {...options});

        const observerCallback = (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.swiper.update();
                    observer.unobserve(entry.target);
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, {
            root: null,
            threshold: 0.1,
        });

        observer.observe(element);
    }
}
